var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16.857,
    viewBox: "0 0 24 16.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#006ebb; }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1612.978,474.864l-6.884,6.884a1.386,1.386,0,0,1-1.961,0l-6.885-6.884a2.422,2.422,0,0,0-4.135,1.712v2.112a4.2,4.2,0,0,0,1.23,2.968l8.346,8.346a3.429,3.429,0,0,0,4.849,0l8.346-8.346a4.2,4.2,0,0,0,1.229-2.968v-2.112A2.422,2.422,0,0,0,1612.978,474.864Z",
    transform: "translate(-1593.113 -474.15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.85426116767ea0673872968a5fe63e5e.svg";
export { ForwardRef as ReactComponent };